import { ApplicationSetting } from '@app/core/model/enums/application-setting.enum'
import { Privilege } from '@app/core/model/enums/privilege.enum'
import { ScopeVersion } from '@app/core/model/scope-version'
import { FolderVersion } from '@core/model/folder-version.model'
import { TableColumnKey } from '@app/shared/components/ui-components/scope-ui-table/table-column-key.enum'
import { TableColumnPreferences } from '@app/shared/components/ui-components/scope-ui-table/table-column-preferences.type'

// Mirrors scopeColumnBaseConfig at
// scope-angular/src/app/features/scoping/models/scope-columns.model.ts
export const folderScopesColumnsBaseConfig: TableColumnPreferences = {
  [TableColumnKey.NAME]: {
    key: TableColumnKey.NAME,
    name: '{LANG:scope.p|u}',
    field: 'name',
    selected: true,
    noSort: true,
    isVisibleInList: () => false,
    valueIconFunction: (scope: ScopeVersion) => {
      switch (scope.identity.identificationType) {
        case 'SCOPE_BY_ROLE':
          return 'table_chart'
        case 'SCOPE_BY_SCENARIO':
          return 'alt_route'
      }
      return scope.isTemplate() ? 'copy_all' : 'equalizer'
    },
  },
  [TableColumnKey.SCOPE_NUMBER]: {
    key: TableColumnKey.SCOPE_NUMBER,
    name: '{LANG:scope} Number',
    field: 'identity.localId',
    selected: true,
  },
  [TableColumnKey.RETAINED_HOURS_USED]: {
    key: TableColumnKey.RETAINED_HOURS_USED,
    name: 'Retained Hours used',
    field: 'retainedHoursUsed',
    selected: true,
    noSort: true,
    requiredSetting: 'SOW__RETAINED_HOURS',
  },
  [TableColumnKey.STATUS]: {
    key: TableColumnKey.STATUS,
    name: 'Status',
    field: 'status',
    selected: true,
    noSort: true,
  },
  [TableColumnKey.RATECARD]: {
    key: TableColumnKey.RATECARD,
    name: 'Ratecard',
    field: 'identity.rateCard.name',
    selected: true,
    noSort: true,
  },
  [TableColumnKey.SCOPE_TYPE]: {
    key: TableColumnKey.SCOPE_TYPE,
    name: '{LANG:scope} Type',
    field: 'identity.scopeType.name',
    selected: true,
    noSort: true,
    requiredPrivilege: Privilege.SCOPE_TYPE__VIEW,
    requiredSetting: ApplicationSetting.SCOPE__TYPE_VIEW,
  },
  [TableColumnKey.CREATED_BY]: {
    key: TableColumnKey.CREATED_BY,
    name: 'Created By',
    field: 'createdBy.company.name',
    selected: true,
    noSort: true,
  },
  [TableColumnKey.DATE_CREATED]: {
    key: TableColumnKey.DATE_CREATED,
    name: 'Date created',
    field: 'createdTs',
    selected: true,
    noSort: true,
  },
  [TableColumnKey.LAST_EDITED]: {
    key: TableColumnKey.LAST_EDITED,
    name: 'Last edited',
    field: 'updatedTs',
    selected: true,
    noSort: true,
  },
  [TableColumnKey.BUDGET]: {
    key: TableColumnKey.BUDGET,
    name: '{LANG:budget}',
    field: 'budget',
    selected: true,
    noSort: true,
  },
  [TableColumnKey.VALUE]: {
    key: TableColumnKey.VALUE,
    name: '{LANG:value}',
    value: (entity: any) => {
      if (entity instanceof FolderVersion) return entity.totalValues || '-'
      if (entity instanceof ScopeVersion) return entity.totalSellingPrice

      return ''
    },
    isVisible: (scope: ScopeVersion) => !scope.containsUnmappedScopeMarkRoles,
    requiredPrivilege: Privilege.SCOPE__VIEW_RATES,
    default: '-',
    noSort: true,
  },
  [TableColumnKey.BALANCE]: {
    key: TableColumnKey.BALANCE,
    name: 'Balance',
    field: 'budgetBalance',
    selected: true,
    noSort: true,
  },
  [TableColumnKey.AGENCY_PRICE]: {
    key: TableColumnKey.AGENCY_PRICE,
    name: '{LANG:agency|p} Price',
    selected: true,
    noSort: true,
    value: (scope: ScopeVersion) => scope.getTotalSellingPrice(),
    requiredPrivilege: Privilege.SCOPE__VIEW_RATES,
    requiredSetting: ApplicationSetting.SCOPE__VIEW_RATES,
  },
  [TableColumnKey.MARGIN]: {
    key: TableColumnKey.MARGIN,
    name: 'Margin',
    field: 'margin',
    selected: true,
    noSort: true,
  },
}

export const folderScopeDeliverablesColumnsBaseConfig: TableColumnPreferences = {
  [TableColumnKey.START_DATE]: { key: TableColumnKey.START_DATE, name: 'Start Date', selected: true },
  [TableColumnKey.END_DATE]: { key: TableColumnKey.END_DATE, name: 'End Date', selected: true },
  [TableColumnKey.QUANTITY]: { key: TableColumnKey.QUANTITY, name: 'Quantity', selected: true },
  [TableColumnKey.CREATED_BY]: { key: TableColumnKey.CREATED_BY, name: 'Created By', selected: true },
  [TableColumnKey.DATE_CREATED]: { key: TableColumnKey.DATE_CREATED, name: 'Date Created', selected: true },
  [TableColumnKey.LAST_EDITED]: { key: TableColumnKey.LAST_EDITED, name: 'Last edited', selected: true },
  [TableColumnKey.VALUE]: { key: TableColumnKey.VALUE, name: 'Value', selected: true },
  [TableColumnKey.BUDGET]: { key: TableColumnKey.BUDGET, name: '{LANG:budget}', selected: true },
  [TableColumnKey.BALANCE]: { key: TableColumnKey.BALANCE, name: 'Balance', selected: true },
  [TableColumnKey.AGENCY_PRICE]: {
    key: TableColumnKey.AGENCY_PRICE,
    name: '{LANG:agency|p} Price',
    selected: true,
    requiredPrivilege: Privilege.SCOPE__VIEW_RATES,
    requiredSetting: ApplicationSetting.SCOPE__VIEW_RATES,
  },
}
